import { APR } from '@makemydeal/dr-dash-components';

export const calculateApr = (value: number, type: string) => (type === APR ? value : Number((value * 2400).toFixed(2)));
